import React, { useState, useRef, useEffect } from "react";
import styles from "./style.module.scss";
import Checkbox from "../../../../../components/Checkbox/Index";
import DropDown from "../../../../../components/DropDown/DropDown";
import KebabIcon from "../../../../../assets/svg/icons/common/kebab";
import WarningIcon from "../../../../../assets/svg/icons/common/Warning";
import RiskIcon from "../../../../../assets/svg/icons/common/risk";
import ConfirmationModal from "../../../../application/components/ConfirmationModal/ConfirmationModal";
import {
  deleteTemplate,
  saveAvailableForTemplates,
} from "../../../../../../api";
import toast from "react-hot-toast";
import useTemplateStore from "../../../../../stores/templates";
import IsAvailableForModal from "../../../components/isAvailableForModal/isAvailableForModal";
import useUserStore from "../../../../../stores/user.js";
import CloneModal from "../../../components/clone-modal";
import { withRouter } from "react-router-dom";

const Row = ({ data, fetchData, history }) => {
  const loggedInUser = useUserStore((state) => state.user);
  const isPCAdmin = useUserStore((state) => state.isPCAdmin);
  const [deleteModal, setDeleteModal] = useState(false);
  const isMountedRef = useRef(true);
  const recordToEdit = useTemplateStore((state) => state.recordToEdit);
  const setRecordToEdit = useTemplateStore((state) => state.setRecordToEdit);
  const isAvailableForOpen = useTemplateStore(
    (state) => state.isAvailableForOpen,
  );
  const setIsAddTemplateModalOpen = useTemplateStore(
    (state) => state.setIsAddTemplateModalOpen,
  );
  const setIsAvailableForModalOpen = useTemplateStore(
    (state) => state.setIsAvailableForModalOpen,
  );

  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        // Fallback for older browsers or non-HTTPS contexts
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        textArea.remove();
      }
      toast.success("Link copied to clipboard");
    } catch (err) {
      console.error("Failed to copy link:", err);
      toast.error("Failed to copy link");
    }
  };

  const dropDownOptions = [
    {
      text: "Copy Link",
      type: "normal",
      onClick: () => {
        if (loggedInUser.agent_url) {
          const linkToCopy = `${window.location.origin}/bank-app/${loggedInUser.agent_url}/${data.id}/v2`;
          copyToClipboard(linkToCopy);
        } else {
          toast.error("Agent URL not found");
        }
      },
    },
  ];
  if (isPCAdmin) {
    dropDownOptions.push({
      text: "Available For",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data);
        setIsAvailableForModalOpen(true);
      },
    });
    dropDownOptions.push({
      text: "Edit",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data);
        history.push(`/templates/${data.id}/edit`);
      },
    });
    dropDownOptions.push({
      text: "Clone Template",
      type: "normal",
      onClick: () => {
        setSelectedTemplate(data);
        setIsCloneModalOpen(true);
      },
    });
    dropDownOptions.push({
      text: "Delete Template",
      type: "danger",
      onClick: () => {
        setRecordToEdit(data);
        setDeleteModal(true);
      },
    });
  } else {
    const canEditTemplate =
      loggedInUser.id === data.created_by ||
      (loggedInUser.role === "admin" &&
        Number(loggedInUser.organization_id) === Number(data.organization_id));

    if (canEditTemplate) {
      dropDownOptions.push({
        text: "Edit",
        type: "normal",
        onClick: () => {
          setRecordToEdit(data);
          history.push(`/templates/${data.id}/edit`);
        },
      });
    }
  }

  const deleteTemp = () => {
    const toastId = toast.loading("Deleting...");
    deleteTemplate({ id: recordToEdit.id }).then((response) => {
      if (response?.success) {
        toast.success("Deleted successfully", { id: toastId });
        fetchData();
        setRecordToEdit(null);
      } else {
        toast.error("Something went wrong", { id: toastId });
        setRecordToEdit(null);
      }
      setDeleteModal(false);
    })
    .catch((error) => {
      toast.error("Something went wrong", { id: toastId });
      setRecordToEdit(null);
    })
    .finally(() => {
      setRecordToEdit(null);
      setDeleteModal(false);
    });
  };

  const saveAvailableFor = (data) => {
    saveAvailableForTemplates(data).then((response) => {
      const toastId = toast.loading("Saving...");
      if (response?.success) {
        toast.success("Available for updated successfully", { id: toastId });
        fetchData();
      } else {
        toast.error("Something went wrong", { id: toastId });
      }
      setRecordToEdit(null);
      setIsAvailableForModalOpen(false);
    })
    .catch((error) => {
      toast.error("Something went wrong", { id: toastId });
      setRecordToEdit(null);
      setIsAvailableForModalOpen(false);
    })
    .finally(() => {
      setRecordToEdit(null);
      setIsAvailableForModalOpen(false);
    });
  };

  return (
    <>
      <tr className={styles.tbodyRow}>
        <td className={styles.td}>{data?.id}</td>
        <td className={styles.td}>{data?.name}</td>
        <td className={styles.td}>{data?.organization?.name}</td>
        <td className={styles.td}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DropDown options={dropDownOptions} direction="bottom">
              <KebabIcon />
            </DropDown>
          </div>
        </td>
      </tr>
      {isAvailableForOpen && (
        <IsAvailableForModal
          open={isAvailableForOpen}
          onClose={() => {
            setIsAvailableForModalOpen(false)
            setRecordToEdit(null)
          }
          }
          onConfirmClick={(id, selectAll, organizations) => {
            saveAvailableFor({
              selectAll: selectAll,
              id: id,
              available_for: organizations,
            });
          }}
        />
      )}
      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          message={`Are you sure you want to delete this template? (${recordToEdit?.name})`}
          onClose={() => {
            setDeleteModal(false);
            setRecordToEdit(null)
          }}
          onConfirmClick={deleteTemp}
        />
      )}
      {isCloneModalOpen && (
        <CloneModal
          isOpen={isCloneModalOpen}
          onClose={() => setIsCloneModalOpen(false)}
          selectedTemplate={selectedTemplate}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

export default withRouter(Row);
